import { render, staticRenderFns } from "./RequEditCust.vue?vue&type=template&id=b40fe740&"
import script from "./RequEditCust.vue?vue&type=script&lang=js&"
export * from "./RequEditCust.vue?vue&type=script&lang=js&"
import style0 from "./RequEditCust.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports